import React from 'react'
import Loadable from 'react-loadable'

import SoftwareReportContext from '../SoftwareReportContext'
import { ApplicationFilters } from '../Filters'
import CloudCoreSummary from '../Summary'

const AllApplicationsTable = Loadable({
  loader: () => import('./AllApplicationsTable'),
  loading: () => <div>Loading...</div>
})

const ApplicationSummary = ({ data }) => (
  <SoftwareReportContext.Consumer>
    {({ filterOptions, filters, changeFilters, toggleSummary }) => (
      <CloudCoreSummary {...{ data, Filters: ApplicationFilters }}>
        <button className="button__link p-0" onClick={() => toggleSummary(true, 'applications')}>
          Show summary
        </button>

        <ApplicationFilters {...{ filters, filterOptions, changeFilters }} />

        <AllApplicationsTable data={data} />
      </CloudCoreSummary>
    )}
  </SoftwareReportContext.Consumer>
)

export default ApplicationSummary
